module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-6-a3107e9e7e6bd42f5ff014f2c83ee155.svg";